$ = require 'jquery'
AllAnnouncements = require 'models/all-announcements'
Storage = require 'lib/storage'
View = require 'view'
template = require 'views/templates/header_announcements'
track = require 'debug/track'
moment = require 'moment'
{ currentLocale } = require '@trello/locale'
f = require 'effing'

module.exports = class AnnouncementHeaderView extends View
  initialize: ->
    @listenTo AllAnnouncements, 'add remove reset',
      @frameDebounce @render

  viewTitleKey: 'announcements'

  events:
    'click .js-blog': 'clickBlog'
    'click .js-t': 'clickTwitter'
    'click .js-fb': 'clickFacebook'
    'click .js-i': 'clickInstagram'
    'click a': 'openAnnouncementLink'

  render: ->
    announcements = AllAnnouncements.forLocale currentLocale

    for announcement in announcements when announcement.isUnread()
      announcement.markRead()

    Storage.set 'tacoShow', moment().add(1, 'hours').valueOf()

    @$el.html template(announcements.map f.method('toJSON'))

    @

  clickBlog: ->
    track("Header", "Announcements Menu", "Trello Blog")

  clickTwitter: ->
    track("Header", "Announcements Menu", "Twitter Link")

  clickFacebook: ->
    track("Header", "Announcements Menu", "Facebook Link")

  clickInstagram: ->
    track("Header", "Announcements Menu", "Instagram Link")

  openAnnouncementLink: (e) ->
    if !$(e.target).closest('a').is('.js-blog, .js-t, .js-fb, .js-g, .js-close-popover')
      track("Info", "Announcements", "Open Announcement Link")



// WEBPACK FOOTER //
// ./app/scripts/views/header/announcement-header-view.coffee